module.exports = __webpack_public_path__ + "img/happy-face.e1ab5cdd.svg";